module.exports = __webpack_public_path__ + "img/img_vs_company_m.a400598f.jpg";